import { configureStore } from "@reduxjs/toolkit";
import authenticationSlice from "./slices/authentication/authenticationSlice";
import chatSlice from "./slices/chat/chatSlice";
import dashboardSlice from "./slices/dashboard/dashboardSlice";
import leaderboardSlice from "./slices/leaderboard/leaderboardSlice";
import myLessonsSlice from "./slices/myLessons/myLessonsSlice";
import userUpdatesSlice from "./slices/userUpdates/userUpdatesSlice";

export const store = configureStore({
  reducer: {
    auth: authenticationSlice,
    chat: chatSlice,
    dashboard: dashboardSlice,
    leaderboard: leaderboardSlice,
    myLessons: myLessonsSlice,
    userUpdates: userUpdatesSlice,
  },
});
